import { replaceWithLogin } from './rootNavigation';
import { currentWebReturnTo } from '../utils/webReturnTo';

/**
 * CORE-2098 — «Войти» из окна «Вход истёк».
 *
 * Адрес возврата берётся ДО всего остального: дальше экран сменится. Сессия
 * забывается до перехода — иначе вход увидел бы ещё «вошедшего» человека и
 * увёл бы его прочь (`useAuthScreenRedirect`). Сам переход — `replace`, как из
 * Live (CORE-2091): комната под входом не остаётся смонтированной.
 */
export async function reloginAfterSessionExpiry(expireSession: () => Promise<void>): Promise<string | undefined> {
  const returnTo = currentWebReturnTo();
  await expireSession();
  replaceWithLogin(returnTo);
  return returnTo;
}
